import React, { useEffect, useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom'
import Hero from '../components/Hero'
import Speakers from '../components/Speakers'
import Schedule from '../components/Schedule'
import EventInfo from '../components/EventInfo'
import Features from '../components/Features'
import Sponsors from '../components/Sponsors'
import SponsorBanner from '../components/SponsorBanner'

const Home = () => {
  const location = useLocation();

  useLayoutEffect(() => {
    // Scroll to top when component mounts
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="relative min-h-screen flex flex-col">
      {/* Background pattern */}
      <div 
        className="fixed inset-0 -z-10 pointer-events-none"
        style={{
          backgroundImage: 'url(/patterns/AMC Gradient Pattern-8.png)',
          backgroundSize: 'cover',
          backgroundRepeat: 'repeat',
          backgroundPosition: 'center',
          opacity: 0.8
        }}
      />
      
      {/* Main content */}
      <div className="relative bg-white bg-opacity-80 flex-1">
        <section className="relative bg-white" style={{ backgroundColor: 'rgba(255, 255, 255, 0.8)' }}>
          <Hero />

          {/* Main content with responsive sidebar layout */}
          <div className="px-1 py-6 sm:py-8">
            <div className="grid grid-cols-1 lg:grid-cols-4 gap-6 lg:gap-8">
              {/* Main content */}
              <div className="lg:col-span-3 order-2 lg:order-1">
                <Features />
                <Speakers />
                <Schedule />
                <Sponsors />
                <EventInfo />
              </div>

              {/* Sidebar */}
              <div className="lg:col-span-1 order-1 lg:order-2">
                <div className="lg:sticky lg:top-[20%] space-y-4 sm:space-y-6">
                  <SponsorBanner page="home" />

                  {/* Additional sidebar content */}
                  <div className="bg-white border-2 border-gray-300 rounded-lg shadow-lg">
                    <div className="bg-gray-800 px-3 py-2 sm:py-3 border-b border-gray-300">
                      <h3 className="text-xs sm:text-sm font-bold text-white uppercase tracking-wide">QUICK LINKS</h3>
                    </div>
                    <div className="p-3 sm:p-4 space-y-2 sm:space-y-3">
                      <a href="/register#/register" className="block text-sm sm:text-base text-blue-700 hover:text-blue-900 font-bold hover:bg-blue-50 p-2 rounded transition-colors">
                        → Conference Registration
                      </a>
                      
                      <a href="/contact#/contact-us" className="block text-sm sm:text-base text-blue-700 hover:text-blue-900 font-bold hover:bg-blue-50 p-2 rounded transition-colors">
                        → Contact Information
                      </a>
                      <a href="/about#/about-us" className="block text-sm sm:text-base text-blue-700 hover:text-blue-900 font-bold hover:bg-blue-50 p-2 rounded transition-colors">
                        → About the Conference
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  )
}

export default Home
